import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({ name: 'shortCurrency' })
export class ShortCurrencyPipe implements PipeTransform {
    constructor(private currencyPipe: CurrencyPipe) {}

    transform(value: number): { amount: string, suffix: string } {
      // Miles de billones (>= 1e12)
      if (value >= 1e12) {
        const num = value / 1e9;
        const formatted = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(num);
        return { amount: `$${formatted}`, suffix: 'B' };
      }
      // Billones (>= 1e11)
      else if (value >= 1e11) {
        const num = value / 1e9;
        const formatted = num.toFixed(1);
        return { amount: `$${formatted}`, suffix: 'B' };
      }
      // Miles de millones (>= 1e8)
      else if (value >= 1e8) {
        const num = value / 1e6;
        const formatted = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(num);
        return { amount: `$${formatted}`, suffix: 'M' };
      }
      // Millones (>= 1e6)
      else if (value >= 1e6) {
        const num = value / 1e6;
        const formatted = num.toFixed(2);
        return { amount: `$${formatted}`, suffix: 'M' };
      }
      // Miles (>= 1e3)
      else if (value >= 1e3) {
        const formatted = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(value);
        return { amount: `$${formatted}`, suffix: '' };
      }
      // Menores a mil
      else {
        // Si el valor es exactamente 0, devolvemos "$0.00"
        if (value === 0) {
          return { amount: '$0.00', suffix: '' };
        }
        // Para otros valores menores a 1000
        const formatted = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(value);
        return { amount: `$${formatted}`, suffix: '' };
      }

      // if (value >= 1000000) {
      //       return { amount: `$${(value / 1000000).toFixed(1)}`, suffix: 'M' };
      //    } else {
      //       return { amount: this.currencyPipe.transform(value,'', 'symbol', '1.2-2') || '', suffix: '' };
      //   }
    }
}
